<template>
  <table class="table table-striped table-condensed">
    <thead>
    <tr>
      <th class="col-xs-6">
        <a href="#" @click.prevent="sort('channel_type')">
          Channel Type <i class="fa fa-sort"></i>
        </a>
      </th>

      <th class="col-xs-4">
        <a href="#" @click.prevent="sort(indexColumn)">
          Index <i class="fa fa-sort"></i>
        </a>
      </th>

      <th class="col-xs-4">
        <a href="#" @click.prevent="sort('value')">
          Revenue <i class="fa fa-sort"></i>
        </a>
      </th>

      <th class="col-xs-4">
        <a href="#" @click.prevent="sort(targetColumn)">
          Target <i class="fa fa-sort"></i>
        </a>
      </th>

      <th class="col-xs-6">
        <a href="#" @click.prevent="sort(differenceColumn)">
          Difference <i class="fa fa-sort"></i>
        </a>
      </th>
    </tr>
    </thead>

    <tbody>
    <template v-for="row in sortedResult">
      <tr>
        <td>
        <span :style="{'background-color': row.color}">
          &nbsp;&nbsp;&nbsp;&nbsp;
        </span>

          &nbsp;

          {{ row.name }}
        </td>

        <td>
          <index-number :value="row[indexColumn]"/>
        </td>

        <td>
          {{ row.value | price }}
        </td>

        <td>
          {{ row[targetColumn] | price }}
        </td>

        <td>
          <difference-number :value="row[differenceColumn]"/>
        </td>
      </tr>

      <tr v-for="subchannelCategory in row.subchannel_categories">
        <td>
          <span>
            &nbsp;&nbsp;&nbsp;&nbsp;
          </span>

          &nbsp;

          <span class="text-muted">
          -&nbsp;{{ subchannelCategory.name }}
          </span>
        </td>
        <td>
          <index-number :value="subchannelCategory[indexColumn]"/>
        </td>
        <td>
          {{ subchannelCategory.value | price }}
        </td>
        <td>
          {{ subchannelCategory[targetColumn] | price }}
        </td>

        <td>
          <difference-number :value="subchannelCategory[differenceColumn]"/>
        </td>
      </tr>
    </template>
    </tbody>

    <tfoot>
    <tr>
      <td>
        Total
      </td>

      <td>
        <index-number :value="totalIndex"></index-number>
      </td>

      <td>
        {{ totalRevenue | price }}
      </td>

      <td>
        {{ totalTarget | price }}
      </td>

      <td>
        <difference-number :value="totalDifference"></difference-number>
      </td>
    </tr>
    </tfoot>
  </table>
</template>

<script>
import DifferenceNumber from '@/components/Numbers/DifferenceNumber'
import IndexNumber from '@/components/Numbers/IndexNumber'

export default {
  components: {DifferenceNumber, IndexNumber},

  props: ['targetMetric', 'result'],

  data() {
    return {
      sortBy: 'channel_type',
      sortDirection: -1,
    }
  },

  computed: {
    targetColumn() {
      if (this.targetMetric === 'ad_target') {
        return 'target'
      }

      return 'management_target'
    },

    indexColumn() {
      if (this.targetMetric === 'ad_target') {
        return 'index'
      }

      return 'management_index'
    },

    differenceColumn() {
      if (this.targetMetric === 'ad_target') {
        return 'difference'
      }

      return 'management_difference'
    },

    sortedResult() {
      return this.result.sort((a, b) => {
        return a[this.sortBy] > b[this.sortBy] ? -this.sortDirection : this.sortDirection
      })
    },

    totalIndex() {
      if (!this.totalTarget) {
        return null
      }

      return this.totalRevenue / this.totalTarget * 100
    },

    totalRevenue() {
      return this.result.reduce((total, row) => {
        return total + row.value
      }, 0)
    },

    totalTarget() {
      return this.result.reduce((total, row) => {
        return total + row[this.targetColumn]
      }, 0)
    },

    totalDifference() {
      return this.result.reduce((total, row) => {
        return total + row[this.differenceColumn]
      }, 0)
    }
  },

  methods: {
    sort(key) {
      if (this.sortBy === key) {
        return this.sortDirection = -this.sortDirection
      }

      this.sortDirection = key === 'channel_type' ? -1 : 1

      this.sortBy = key
    }
  }
}
</script>
